import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { MediaOfferingRow } from "./MediaOfferingRow";

interface MediaOffering {
  media_id: number;
  media_name: string;
  media_descr: string | null;
  price: number;
  is_available: boolean;
}

interface MediaOfferingsTableProps {
  mediaOfferings: MediaOffering[];
  onPriceChange: (mediaId: number, price: string) => void;
  onAvailabilityChange: (mediaId: number, isAvailable: boolean) => void;
}

export function MediaOfferingsTable({
  mediaOfferings,
  onPriceChange,
  onAvailabilityChange,
}: MediaOfferingsTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Media Type</TableHead>
          <TableHead>Description</TableHead>
          <TableHead>Price</TableHead>
          <TableHead>Available</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {mediaOfferings?.map((media) => (
          <MediaOfferingRow
            key={media.media_id}
            media_name={media.media_name}
            media_descr={media.media_descr}
            price={media.price}
            is_available={media.is_available}
            onPriceChange={(price) => onPriceChange(media.media_id, price)}
            onAvailabilityChange={(checked) => 
              onAvailabilityChange(media.media_id, checked)
            }
          />
        ))}
      </TableBody>
    </Table>
  );
}